import {
  ACCESS_TOKEN,
  LOGGED_IN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_EXPIRED,
  TOKEN_EXPIRED,
  TOKEN_TYPE,
} from "../const";

export const clearTokenInformation = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_EXPIRED);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN_EXPIRED);
  localStorage.removeItem(TOKEN_TYPE);
  localStorage.removeItem(LOGGED_IN);
};

export const setTokenLocalStorage = (tokenInfo) => {
  const { accessToken, expiresIn, refreshToken, refreshExpiresIn, tokenType } =
    tokenInfo;

  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(TOKEN_EXPIRED, expiresIn);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  localStorage.setItem(REFRESH_TOKEN_EXPIRED, refreshExpiresIn);
  localStorage.setItem(TOKEN_TYPE, tokenType);
  localStorage.setItem(LOGGED_IN, true);
};
